import plainStyle from './utils/plainStyle';
import * as RuntimeOptions from './RuntimeOptions';
export function getAlias(prop, type) {
    var _a, _b;
    prop = prop.replace('className', 'class');
    var hostComponent = RuntimeOptions.get('hostComponents')[type];
    var prefix = RuntimeOptions.get('platform') + "-";
    // 判断是否是平台独有属性
    if (prop.startsWith(prefix)) {
        return prop.replace(new RegExp("^" + prefix), '');
    }
    return (_b = (_a = hostComponent === null || hostComponent === void 0 ? void 0 : hostComponent.alias) === null || _a === void 0 ? void 0 : _a[prop]) !== null && _b !== void 0 ? _b : prop;
}
function getValue(prop, value) {
    if (prop.toLowerCase().endsWith('style') && Object.prototype.toString.call(value) === '[object Object]') {
        return plainStyle(value);
    }
    return value;
}
export function propAlias(prop, value, type) {
    return [getAlias(prop, type), getValue(prop, value)];
}
export default function propsAlias(props, type) {
    if (!props) {
        return props;
    }
    var aliasProps = {};
    for (var prop in props) {
        aliasProps[getAlias(prop, type)] = getValue(prop, props[prop]);
    }
    return aliasProps;
}
